/** Which neighbours a shelf may merge with, as PSA and fixture files encode it. */
export enum FixtureCanCombine {
  NONE = 0,
  BOTH = 1,
  LEFT = 2,
  RIGHT = 3,
}

export const canMergeLeft = (canCombine: number | null | undefined) =>
  canCombine === FixtureCanCombine.BOTH || canCombine === FixtureCanCombine.LEFT;

export const canMergeRight = (canCombine: number | null | undefined) =>
  canCombine === FixtureCanCombine.BOTH || canCombine === FixtureCanCombine.RIGHT;

export const canCombineFromSides = (left: boolean, right: boolean): FixtureCanCombine =>
  left && right
    ? FixtureCanCombine.BOTH
    : left
      ? FixtureCanCombine.LEFT
      : right
        ? FixtureCanCombine.RIGHT
        : FixtureCanCombine.NONE;

export const withoutLeft = (canCombine: number | null | undefined) =>
  canCombineFromSides(false, canMergeRight(canCombine));

export const withoutRight = (canCombine: number | null | undefined) =>
  canCombineFromSides(canMergeLeft(canCombine), false);
